import {Component,  AfterViewInit, OnDestroy, OnInit} from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';
import {AppService} from '../../commons/app.service';
import {FourDService, ProcessorAPI, AccountPlan, BillingSetup, Invoice,AccountPlanImpl, Account} from '4d-mapper';
import {MatSnackBar, MatDialog} from '@angular/material';
import {QMAP} from 'ng-qmap';
import {TranslateService} from '@ngx-translate/core';
import {AppBaseComponent} from '../../commons/AppBaseComponent';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import { UiManagerService } from '@src/app/xs/services/ui/ui-manager.service';
import {Element as StripeElement, Elements, ElementsOptions, StripeService} from 'ngx-stripe';
import { BillingDialogComponent } from './billing-dialog.component';
import {PhotogramEstimatePriceDialog} from './photogram-estimate-price/photogram-estimate-price-dialog.component';

// generic helpers
import {Constants} from './../../commons/Constants';
import { XsApplicationEventsService } from '../../xs/services/events/application-events.service';
import { FileDataService } from '../../v2/commons/file-data.service';
import { AclService } from '@src/app/commons/acl/acl.service';

const BTClient = require('braintree-web/client');
const BTDropIn = require('braintree-web-drop-in');
const BTHostedFields = require('braintree-web/hosted-fields');


@Component({
  selector: 'billing-comp',
  templateUrl: './billing.component.html',
  styleUrls: ['./billing.component.css']

})
export class BillingComponent extends AppBaseComponent implements OnInit, OnDestroy {

  // refactor

  currencySign:string = '$';

  // adjustments of a plan (regardless if we're changing the plan or not)
  adjustments:boolean = false;

  // old code

  error: string
  success: string

  plans: AccountPlan[]
  billingSetup: BillingSetup
  voucher: any [];
  isNewCard:boolean
  editCC: boolean

  selectedPlan:AccountPlan = null;

  account:Account
  
  invoices:Invoice[]

  adjustUsers:boolean = false;
  adjustStorage:boolean = false;
  adjustProjects:boolean = false;
  
  adjustedUsers:number = 0;
  adjustedProjects:number = 0;
  adjustedStorage:number = 0;

  cc = {}

  btInstance: any

  BILLING_QMAP = [
    {id: 'name'},
    {id: 'company'},
    {id: 'email'},
    {id: 'phone'}
  ]
  stats:any
  stripeTest: FormGroup;
  elementsOptions: ElementsOptions = {
    locale: 'auto'
  };
  elements: Elements;
  card: StripeElement;
  private stripeInitialized: boolean = false;
  estimatedPrice: any;


  planAdjustments:AccountPlanImpl
  curPlanAdjustments:AccountPlanImpl


  // whether to show 'other' option for buying credits
  showOther:boolean = false;
  otherValue:number = 10;

  show:any = {
    showCredits: true
  };

  isJapan:boolean = false;
  
  constructor(public fourD: FourDService, public service: AppService, public router: Router,
              public snackBar: MatSnackBar, 
              public dialog: MatDialog, 
              private activeRoute: ActivatedRoute,
              public translate: TranslateService,
              private stripeService: StripeService,
              private v2FileService:FileDataService,
              public uiManager: UiManagerService,
              public permissions: AclService,
              private fb: FormBuilder, applicationEvents:XsApplicationEventsService) {
    super(service, router, snackBar, dialog, applicationEvents);
    this.stripeTest = this.fb.group({
      name: ['', [Validators.required]]
    });

    /*
       this.sub = this.fourD.aa().subscribe(s =>
           this.apis = this.fourD.apis.filter(ap => ap.account.id == this.fourD.aa.id)
    )
    */
  }

  isTrialDays:number
  onReady() {
    this.account = this.fourD.activeTeam;
    this.account.fetchObservable().subscribe();


    console.log ( "!");
    this.fourD.getQuotas().subscribe(s => { 
      this.stats = s;
      console.log ( "!!",s);
    })

    let team = this.fourD.activeTeam;
    let hostname:string = team['hostname'] ? team['hostname'] : 'other'; 
    this.isJapan = hostname.indexOf('link') !== -1 ? true : false;
    let plan:number = this.fourD.activeTeam.plan.id;

    // remove ppk plan
    this.fourD.plans = this.fourD.plans.filter(a => a.seq >= 0);
    this.plans = this.fourD.plans.filter(a => !a.isTrial);
    if(this.fourD.activeTeam.plan.isTrial){
      if(this.fourD.activeTeam['trialEndDate'])
        this.isTrialDays = Math.round((this.fourD.activeTeam['trialEndDate'] - new Date().getTime()) / (3600000*24))
      this.plans.push(this.fourD.activeTeam.plan)
    }
    else {
      this.isTrialDays = null
    }

    this.plans.sort((a,b) => {
      return a.cost - b.cost
    })

    this.plans.forEach ( plan => {
      plan['showCredits'] = true;
      if ( this.isJapan ) {
        if ( plan['uid'] == 'std' || plan['uid'] == 'Basi_1' || plan['uid'] == 'Adva_1' || plan['uid'] == 'Prem_1' ) {
          plan['showCredits'] = false;
        }
      }
    });
    
    // hide HangOn / waiting box (if open)
    Constants.hideHangOn();

    this.fourD.V.searchByObject(Invoice)
      .equals('status','paid')
      .sortBy('dateMade',true)
      .queryObservable().subscribe(res => {
        this.invoices = res.items
    });

    if ( ! this.selectedPlan ) {
      this.selectedPlan = this.fourD.activeTeam.plan;
      this.fourD.activeTeam.accountPlanDetails().subscribe(s => {
        this.planAdjustments = s
        this.curPlanAdjustments = Object.assign({}, s);
      });
    }
    
    return this.fourD.V.searchByObject(BillingSetup)
      .equals('account', this.fourD.activeTeam.id)
      .equals('active', true)
      .queryObservable().subscribe(res => {
        if(res.items.length){
          this.billingSetup = res.items[0];
        
        }
    });

  }

 // Switch from one plan to another
  switchPlan(p:AccountPlan){
    this.translate.get('PLAN.PLAN_TRANSITION',{
      fromPlan:this.fourD.activeTeam.plan.name,
      fromPrice:this.curPlanAdjustments.price,
      toPlan:this.selectedPlan.name ,
      toPrice:this.planAdjustments.price
    }).subscribe(s => 
    this.openDialog('GENERIC.CONFIRM',s,"GENERIC.OK","GENERIC.CANCEL").subscribe(s => {
      if(s){
        this.fourD.activeTeam.updatePlan(this.planAdjustments,this.selectedPlan).subscribe(_ => {
          this.openDialog('GENERIC.SUCCESS','PLAN.PLAN_CHANGED')

          this.v2FileService.refreshWidgets().subscribe()
          this.onReady()
        },
          e => this.openDialog('GENERIC.ERROR', e.message)
        )
      }

    }))
  }

  showThumblabel ( me:any ) {
    me.source.thumbLabel = true;
  }
  hideThumblabel ( me:any ) {
    me.source.thumbLabel = false;
  }

  reset() {
    this.adjustments = false;
    this.selectedPlan = this.fourD.activeTeam.plan;
    this.updateSliders(false);
  }

  updateSliders(usePreview:boolean){

    if(usePreview){
      this.fourD.activeTeam.previewPlan(this.planAdjustments,this.selectedPlan).subscribe(s => {
        this.planAdjustments = s;
        this.updateAdjustments();
      });
    }
    else{
    this.fourD.activeTeam.accountPlanDetails(this.selectedPlan).subscribe(s => {
      this.planAdjustments = s;
      this.updateAdjustments();
    });
    }
  }
  updateAdjustments() {

    this.adjustedUsers = 0;
    if ( this.planAdjustments && this.planAdjustments.allAdjustments['users'] ) {
      this.adjustedUsers = this.planAdjustments.allAdjustments['users'];
    }
    this.adjustedProjects = 0;
    if ( this.planAdjustments && this.planAdjustments.allAdjustments['projects'] ) {
      this.adjustedProjects = this.planAdjustments.allAdjustments['projects'];
    }
    this.adjustedStorage = 0;
    if ( this.planAdjustments && this.planAdjustments.allAdjustments['storage'] ) {
      this.adjustedStorage = this.planAdjustments.allAdjustments['storage'];
    }
    
  }

  topup(amount:Number){
      
    // Adding credit
    this.translate.get('PLAN.ADDING_CREDIT',{amount:amount}).subscribe(s => 
      this.openDialog('GENERIC.CONFIRM',s,'PLAN.PURCHASE','GENERIC.CANCEL').subscribe(s => {
        if(s){
          this.account.buyCredit(amount).subscribe(s => {
            this.onReady()
            this.openDialog('GENERIC.SUCCESS','PLAN.CREDIT_ADDED')
          }, e=> this.openDialog('GENERIC.ERROR',e.message))
        }
      })
    )
  }
  setDetails(){
    var ref = this.dialog.open(BillingDialogComponent,{
      width:'75%',
      data:{

      }
    })

    ref.afterClosed().subscribe( success => {
      // if plan was success, then reset the selectedPlan to inject new values
      if ( success ) {
        this.selectedPlan = null;
      }
      this.onReady(); 
    });
  }

  openEstimatePriceDialog() {
    var ref = this.dialog.open(PhotogramEstimatePriceDialog,{
      width:'50%',
      data:{

      }
    })

    ref.afterClosed().subscribe(value => this.estimatedPrice = value )
  }

  cancelSubscription() {
    this.openDialogWithMeta( {deletename: name}, 'GENERIC.DIALOG.DELETE.TITLE','PLAN.ASK_CANCEL_SUBSCRIPTION',  'GENERIC.YES', 'GENERIC.NO').subscribe(s => {
      this.billingSetup['payCycle'] = '';
      this.billingSetup['plan'] = this.fourD.plans.filter(a => a.isTrial && a.seq >= 0)[0].id;
      this.billingSetup.saveObservable().subscribe(s => {
        this.fourD.activeTeam.fetchObservable().subscribe(_ =>  this.onReady())
      });
    });
  }
}